import { render, staticRenderFns } from "./showTitle.vue?vue&type=template&id=0ac2df52&scoped=true&"
var script = {}
import style0 from "./showTitle.vue?vue&type=style&index=0&id=0ac2df52&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac2df52",
  null
  
)

export default component.exports